"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'limits.avatar.exceeded': 'Límite de avatares alcanzado. Actualice su plan para crear más avatares.',
    'limits.avatar.limitReached': 'Límite de avatares: {limit} (actualizar para más)',
};
